/**
 * DC-Leitungslaenge je String (Kapitel H, Rueckmeldung aus dem ersten Test
 * bei Wania: "Leitungslaengen zum String dazu").
 *
 * Ein String braucht auf dem Dach kaum eigenes Kabel: Jedes Modul hat zwei
 * Anschlussleitungen, und Nachbarn stecken direkt zusammen. Kabel braucht es
 * an drei Stellen:
 *
 *   Verlaengerungen — wo zwei Module im String weiter auseinander liegen, als
 *   ihre Anschlussleitungen reichen, etwa ueber ein Dachfenster hinweg.
 *
 *   Rueckfuehrung — Plus und Minus gehen gemeinsam zum Wechselrichter. Das
 *   Ende des Strings muss also zurueck zum Anfang. Im Maeander liegt das Ende
 *   neben dem Anfang, in einer einzelnen Reihe am anderen Ende.
 *
 *   Zuleitung — vom Dach bis zum Wechselrichter, zweimal (Plus und Minus).
 *   Dieser Weg steht nicht auf der Karte; er wird je String eingetragen.
 *
 * Gerechnet wird mit Luftlinie zwischen Modulmitten. Der Verlegezuschlag
 * kommt in der Materialliste dazu (PV-J04), nicht hier.
 */
const abstand = (a, b) => Math.hypot(b.x - a.x, b.y - a.y);
export function stringleitung(e) {
    if (e.mitten.length === 0) {
        return { verlaengerungen: 0, verlaengerungenM: 0, rueckfuehrungM: 0, zuleitungM: 0, gesamtM: 0, steckerpaare: 0 };
    }
    const reichweite = 2 * e.anschlussleitungM;
    let verlaengerungen = 0;
    let verlaengerungenM = 0;
    for (let i = 1; i < e.mitten.length; i++) {
        const fehlt = abstand(e.mitten[i - 1], e.mitten[i]) - reichweite;
        if (fehlt > 1e-9) {
            verlaengerungen++;
            verlaengerungenM += fehlt;
        }
    }
    const rueckfuehrungM = abstand(e.mitten[0], e.mitten[e.mitten.length - 1]);
    const zuleitungM = 2 * e.zuleitungM;
    return {
        verlaengerungen,
        verlaengerungenM,
        rueckfuehrungM,
        zuleitungM,
        gesamtM: verlaengerungenM + rueckfuehrungM + zuleitungM,
        steckerpaare: 2 + 2 * verlaengerungen,
    };
}
//# sourceMappingURL=stringleitung.js.map